module.exports = __webpack_public_path__ + "img/flecha-menu.02ba128a.svg";